import { createContext } from "react";

export const dateFormats = ["iso", "eu", "us", "written"] as const;
export const timeFormats = ["24hour", "24hour+sec", "12hour", "12hour+sec"] as const;
export const timeSpanFormats = ["normal", "written"] as const;

export interface Settings {
  colorScheme: null | "light" | "dark";
  firstDayOfWeek: number;
  dateFormat: null | typeof dateFormats[number];
  timeFormat: null | typeof timeFormats[number];
  timeSpanFormat: typeof timeSpanFormats[number];
  language: string;
  showDebugInfo: boolean;
  ringtoneVolume: number; // float between 0 and 1
}

export type SettingsContextValue = [
  settings: Settings,
  setSettings: (value: Partial<Settings> | ((currentSettings: Settings) => Partial<Settings>)) => void,
];

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const SettingsContext = createContext<SettingsContextValue>(undefined!);
